import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import StageHeader from '../../components/stageHeader';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './verifyEmail.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import Datepicker from 'vuejs-datepicker';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsServiceToJson from '../../services/axios/tmsServiceToJson';
import { cloneDeep } from 'lodash-es';
@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
    },
})
export default class VerifyEmails extends Vue {
    verifyEmail: any = {};
    businessVerify: any = {};
    moudleName: string = 'welcomeToUnis';
    // moudleName: string = "tellUsAboutYourBusiness";
    // moudleState: string = "complete";
    moudleState: string = 'operation';
    confirmPassword: boolean = true;
    isshowPassword: boolean = true;
    isVerifyEmail: boolean = false;
    isTellBusinessLoding: boolean = false;
    isVerifyEmailToBusiness: boolean = false;
    businessTypes: Array<any> = [
        { key: 1, code: null, title: 'Residential/End user' },
        { key: 2, code: 'CON', title: 'Sole Proprietor/Small business' },
        { key: 3, code: 'SHOW', title: 'Medium - Large business' },
        { key: 4, code: null, title: 'Fortune 500/Global organization' },
        { key: 5, code: 'RES', title: 'Government/NGO' },
        { key: 6, code: null, title: 'Trucking/Warehousiing' },
    ];

    created() {}

    onSubmitVerifyEmail(scope: any) {
        this.$validator.validateAll(scope).then(res => {
            if (res) {
                this.isVerifyEmail = true;
                tmsServiceToJson.post('/apinew/cp/user/create', this.verifyEmail).then(
                    (response: any) => {
                        this.isVerifyEmail = false;
                        if (response.data.status == 1) {
                            this.businessVerify.user_id = response.data.data.userId;
                            this.businessVerify.location_id = response.data.data.locationId;
                            this.userCompanyname();
                        }
                    },
                    (err: any) => {
                        this.isVerifyEmail = false;
                        if (err.response.data && err.response.data.message) {
                            this.err(err.response.data.message);
                        }
                    }
                );
            }
        });
    }

    linkBusiness() {
        if (this.isVerifyEmailToBusiness) {
            this.moudleName = 'welcomeToUnis';
        }
    }

    onSubmitTellBusiness(scope: any) {
        this.$validator.validateAll(scope).then(res => {
            if (res) {
                tmsServiceToJson.post('/apinew/cp/user/update', this.businessVerify).then(
                    (response: any) => {
                        if (response.data.status == 1) {
                            this.userCompanyname();
                            return;
                        }
                        if (response.data.status == -1) {
                            this.isVerifyEmail = false;
                            console.log(response.data);
                        }
                    },
                    (err: any) => {
                        this.isVerifyEmail = false;
                        if (err.response.data.status == -1 && err.response.data.message) {
                            this.err(err.response.data.message);
                            return;
                        }
                        if (err.response.data && err.response.data.message) {
                            if (err.response.data.message.length > 0) {
                                this.err(err.response.data.message.user_id[0]);
                            } else {
                                if (err.response.data.message.user_id) {
                                    this.err(err.response.data.message.user_id[0]);
                                    return;
                                }
                                if (err.response.data.message.company_name) {
                                    this.err(err.response.data.message.company_name[0]);
                                    return;
                                }
                                this.err(err.response.data.message);
                            }
                        }
                    }
                );
            }
        });
    }

    userCompanyname() {
        let parames = {
            UserID: this.businessVerify.user_id,
            UserToken: localStorage.getItem('UserToken'),
            company_name: this.verifyEmail.company_name,
        };
        tmsServiceToJson.post('/apinew/cp/user/companyname', parames).then(
            (response: any) => {
                this.isVerifyEmail = false;
                if (response.data.status == 1) {
                    this.moudleState = 'complete';
                }
                if (response.data.status == -1) {
                    console.log(response.data);
                }
            },
            (err: any) => {
                this.isVerifyEmail = false;
                if (err.response.data && err.response.data.message) {
                    if (err.response.data.message.length > 0) {
                        this.err(err.response.data.message.user_id[0]);
                    } else {
                        if (err.response.data.message.user_id) {
                            this.err(err.response.data.message.user_id[0]);
                            return;
                        }
                        this.err(err.response.data.message);
                    }
                }
            }
        );
    }

    clickFold(tagName: string) {}

    mounted() {
        let name,
            value,
            str = location.href,
            num = str.indexOf('?');
        str = str.substr(num + 1);
        let arr = str.split('&');
        console.log('arr', arr);
        let parameter = {};
        for (let i = 0; i < arr.length; i++) {
            num = arr[i].indexOf('=');
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                if (name == 'email') value = unescape(value);
                if (name == 'form') {
                    this.moudleName = 'tellUsAboutYourBusiness';
                }
                parameter[name] = value;
            }
        }
        this.verifyEmail.email = parameter['email'];
        this.verifyEmail.code = parameter['code'];
    }

    returnToSignIn() {
        this.$router.push({
            name: 'Home',
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/verifyEmail/index.ts